import * as React from 'react';
import { ITimerOptions } from './TimerOptions';
import Clock from './Clock';
import ClockOptions from './ClockOptions';
import MessageService from './MessageService';
import { RouteComponentProps, Redirect } from 'react-router';
import { TimerCode } from './TimerCode';
import { WaitingForTimer } from './WaitingForTimer';
import * as Utils from '../Utils';

interface ITimerState {
  options: ITimerOptions;
  state: TimerState;
}

interface ITimerRouteProps {
  timerCode?: string;
  myTimerCode?: string;
}

enum TimerState {
  WAITING, STARTED, ENDED, CANCEL
}

export default class Timer extends React.Component<RouteComponentProps<ITimerRouteProps>, ITimerState> {

  constructor(props: RouteComponentProps<ITimerRouteProps>) {
    super(props);
    const timerCode = Number(props.match.params.timerCode);
    const myTimerCode = props.match.params.myTimerCode ? Number(props.match.params.myTimerCode) : undefined;
    let getHook = "";
    if (window.localStorage.getItem("getHookvisible") === "true") {
      getHook = window.localStorage.getItem("getHook") || "";
    }
    const state: ITimerState = {
      state: TimerState.STARTED,
      options: {
        duration: parseInt(window.localStorage.getItem("duration") || "1000", 10),
        startedMs: Utils.getNowLocal(),
        notification: Notification.permission === "granted",
        notificationText: window.localStorage.getItem("notificationText") || undefined,
        getHook,
        myTimerCode
      }
    }
    if (timerCode && !isNaN(timerCode) && timerCode.toString().length === 6) {
      state.state = TimerState.WAITING
      state.options.timerCode = timerCode;
      setImmediate(() => this.subscribe(this.state.options));
    } else {
      this.sendTimerUpdateMessage(state.options);
    }
    this.state = state;
    this.onEnd = this.onEnd.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.subscribe = this.subscribe.bind(this);
  }

  public render() {
    if (this.state.state === TimerState.CANCEL) {
      return <Redirect to="/timer" />;
    }
    let timerCode = this.state.options.timerCode;
    if (!timerCode) {
      timerCode = this.state.options.myTimerCode;
    }
    return (
      <div className="flex-grow-1 d-flex flex-nowrap justify-content-center align-items-center flex-column h-100">
        <TimerCode timerCode={this.state.options.timerCode || this.state.options.myTimerCode} />
        {this.state.state === TimerState.WAITING ?
          <WaitingForTimer />
          :
          <Clock options={this.state.options} onEnd={this.onEnd} started={this.state.state === TimerState.STARTED} />
        }
        <ClockOptions onCancel={this.onCancel} onAdd={this.onAdd} addEnabled={this.state.options.timerCode === undefined} />
      </div>
    )
  }

  public componentWillUnmount() {
    if (this.state.options.timerCode) {
      MessageService.unsubscribe();
    }
  }

  private subscribe(options: ITimerOptions) {
    if (!options.timerCode) {
      return;
    }
    MessageService.subscribe(options.timerCode, async (remoteOptions) => {
      remoteOptions.startedMs = await Utils.uncorrectTime(remoteOptions.startedMs);
      this.setState({
        options: remoteOptions,
        state: TimerState.STARTED
      });
    });
  }

  private onEnd() {
    this.setState({
      state: TimerState.ENDED
    });
    if (this.state.options.notification) {
      // tslint:disable-next-line:no-unused-expression
      new Notification("Timer", {
        badge: "favicon.ico",
        body: this.state.options.notificationText || "Time is over",
        icon: "favicon.ico"
      });
    }
    if (this.state.options.getHook) {
      fetch(this.state.options.getHook, {
        mode: "no-cors"
      });
    }
  }

  private onCancel() {
    if (this.state.options.timerCode) {
      MessageService.unsubscribe();
    }
    this.setState({
      state: TimerState.CANCEL
    });
  }

  private onAdd(additionalDuration: number) {
    if (this.state.state === TimerState.STARTED) {
      const newOptions = {
        ...this.state.options,
        duration: this.state.options.duration + additionalDuration
      };
      this.setState({
        options: newOptions
      });
      this.sendTimerUpdateMessage(newOptions);
    } else if (this.state.state === TimerState.ENDED) {
      const newOptions = {
        ...this.state.options,
        startedMs: new Date().getTime(),
        duration: additionalDuration
      };
      this.setState({
        state: TimerState.STARTED,
        options: newOptions
      });
      this.sendTimerUpdateMessage(newOptions);
    }
  }

  private async sendTimerUpdateMessage(options: ITimerOptions) {
    if (options.myTimerCode) {
      const correctedStartedMs = await Utils.correctTime(options.startedMs);
      MessageService.shareTimer({
        ...options,
        timerCode: options.myTimerCode,
        startedMs: correctedStartedMs
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/Timer/Timer.tsx